<template>
  <div class="father-home">
    <el-container>
      <!-- v-if="service_id" -->
      <el-header :style="`height:${header_height}px `">
        <homeheader :aname="mch_name" :btnsize="btn_size" @showDraw="showDraw(true)"></homeheader>
      </el-header>
      <el-container :style="`height:calc(100% - ${header_height}px)`">
        <!-- 头部区域 -->
        <el-aside v-if="aside_show" style="height:100%" :width="'80px'">
          <homeaside v-if="homeaside_show" :list="menu_list" :isCollapses="true" @Collapse="getCollapse"></homeaside>
        </el-aside>
        <el-drawer title="我是标题" direction="ltr" :visible.sync="draw_show" :with-header="false" size="80px">
          <!-- <homeaside :isltr="true" v-if="homeaside_show" :isCollapses="false" :unclicks="false" :list="menu_list" @Collapse="getCollapse"
            @hideDraw="showDraw(false)"></homeaside> -->
            <homeaside v-if="homeaside_show" :list="menu_list" :isCollapses="true" @hideDraw="showDraw(false)" @Collapse="getCollapse"></homeaside>
        </el-drawer>
        <el-main>
          <homemain></homemain>
        </el-main>
      </el-container>
    </el-container>
    <div class="wty-dialog" v-if="qrcode_show">
      <wxQrcode ref="wxQrcodeRef" @showQrCode="showQrCode"></wxQrcode>
    </div>
    <!-- <el-container>
      <el-header>Header</el-header>
      <el-container>
        <el-aside width="200px">Aside</el-aside>
        <el-main>Main</el-main>
      </el-container>
    </el-container> -->
  </div>
</template>
<script>
import homemain from "../components/homemain.vue";
import homeheader from "../components/homeheader.vue";
import homeaside from "../components/homeaside.vue";
import { servehomemenu, shophomemenu } from "@/js/menulist.js";
import wxQrcode from "../components/wxQrcode.vue";
export default {
  inject: ["reload"],
  components: { homeaside, homeheader, homemain, wxQrcode },
  provide() {
    return {
      showDialog: this.showDialog
    };
  },
  data() {
    return {
      qrcode_show: false,
      draw_show: false,
      homeaside_show: true,
      header_height: "",
      isCollapse: false,
      activePath: "",
      showBox: false,
      merchant_id: "",
      mch_name: "",
      merchants: [],
      subtract: "",
      // 控制侧边栏隐藏显示按钮是否可点击
      unclick: false,
      aside_show: true,
      title_width: "",
      btn_size: "medium",
      service_id: localStorage.getItem("service_id"),
      menu_list: []
    };
  },
  computed: {
    availWH() {
      return this.$store.state.resolution.availWH;
    },
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        // console.log("newInner----------", newinner);
        if (newinner.innerWidth < 1200) {
          this.aside_show = false;
        } else {
          this.aside_show = true;
        }
        if (newinner.innerHeight < 700) {
          this.header_height = "40";
        } else {
          this.header_height = "60";
        }
      },
      deep: true,
      immediate: true
    }
  },

  async created() {
    this.getMenuList();
    this.merchant_id = localStorage.getItem("mch_id");
  },
  async mounted() {
    window.showQrCode = this.showQrCode;
    //console.log("mounted设置window.showQrCode");
  },

  methods: {
    //显示扫码登录
    showQrCode(res) {
      return new Promise((resolve, reject) => {
        this.qrcode_show = res;
        if (this.qrcode_show === true) {
          this.$nextTick(() => {
            //console.log("home显示二维码组件");
            this.$refs.wxQrcodeRef.flush();
            resolve(true);
          })
        }
        resolve(false);
      })
    },
    showDraw(e) {
      // console.log(e);
      this.draw_show = e;
    },

    getMenuList() {
      // this.menu_list = shophomemenu;

      this.homeaside_show = false;
      if (
        localStorage.getItem("token_type") === "service" ||
        localStorage.getItem("login_type") === "service"
      ) {
        // return servehomemenu;
        this.$nextTick(() => {
          this.menu_list = servehomemenu;
          this.homeaside_show = true;
        });
      }
      if (
        localStorage.getItem("token_type") === "merchant" ||
        localStorage.getItem("login_type") === "merchant"
      ) {
        // return shophomemenu;
        this.$nextTick(() => {
          this.menu_list = shophomemenu;
          this.homeaside_show = true;
        });
      }
      //TODO: 为了使用goodsInfo
      // this.menu_list = servehomemenu;
    },
    /* aside 返回值： */
    getCollapse(res) {
      this.isCollapse = res;
    },
    // 退出
    /*     lohout() {
      localStorage.clear();
      this.$router.push("/servicerlogin");
    }, */
    // 点击按钮让菜单折叠和展开
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    /* togCollapse() {
      this.isCollapse = true;
    }, */
    // 刷新之后也可以保持高亮状态
    /* saveNavState(activePath) {
      localStorage.setItem("activePath", activePath);
      this.activePath = activePath;
    }, */
    manageMerchant(e) {
      var that = this;
      localStorage.setItem("mch_id", this.merchant_id);
      this.merchants.forEach(function (item, i, arr) {
        //console.log("item----------------------", item);
        localStorage.setItem("mch_id", that.merchant_id);
        localStorage.setItem("mch_name", item.mch_name);
        //console.log(localStorage.getItem("mch_name"));
      });
    },
    /* saveInfo() {
      if (this.merchant_id == "" || this.merchant_id.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择店铺"
        });
        return;
      }
      this.$confirm(
        "修改店铺当前页面的操作会丢失请先确认是否有未保存的操作",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.reload();
          this.showBox = false;
          this.$message({
            type: "success",
            message: "修改成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改"
          });
        });
    }, */
    closureBox() {
      this.showBox = false;
    },
    goHome() {
      localStorage.removeItem("activePath");
      //换一个其他的路径吧
      // this.$router.push("welcome");
      this.reload();
    }
    //商店页面
  }
};
</script>
<style lang="less" scoped>
.father-home {
  width: 100%;
  height: 100%;
  min-height: 550px;
  /* max-height: 1000px; */
  background-color: #fff;
  display: flex;
  border-radius: 5px;
  padding-top: 5px;
}
.wty-dialog {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: rgba(1, 1, 1, 0.8);
  z-index: 2003;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-header {
  display: flex;
  justify-content: space-between;
  /* background-color: #7ab7ef; */
  align-items: center;
  /* color: #fff; */
  font-size: 24px;
  border-bottom: 1px solid #dcdfe6;
  overflow: hidden;
}

/deep/.el-tabs__header {
  margin: 0;
}

/deep/.el-card {
  border: 1px solid #dcdfe6;

  border-top: none;
  padding: 0;
}

.el-header div {
  display: flex;
  align-items: center;
}

.el-header-img {
  cursor: pointer;
  height: 60px;
  margin-right: 15px;
}

.el-aside {
  background-color: #fff;
  border-right: 1px solid #dcdfe6;
  /* box-shadow: 5px 5px 5px rgb(12, 12, 12); */
}

.el-aside::-webkit-scrollbar {
  display: none;
}

.el-main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 0;
  /* background-image: url(../assets/pic/spz.jpeg); */
  /* background-image: url(../assets/0001.jpg); */
}

span {
  font-weight: 700;
}
</style>
